"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.COMPONENT = exports.BUSINESS_UNIT = void 0;
var BUSINESS_UNIT = {
  INSPIRATION: 'INSPIRATION',
  // Deprecated: Use MARKETPLACE for marketplace couples
  INVITATIONS: 'INVITATIONS',
  MARKETPLACE: 'MARKETPLACE',
  MARKETPLACE_COUPLES: 'MARKETPLACE_COUPLES',
  // Deprecated: Use MARKETPLACE for marketplace couples
  MARKETPLACE_VENDORS: 'MARKETPLACE_VENDORS',
  REGISTRY: 'REGISTRY',
  WEDDINGS: 'WEDDINGS',
  WEDDING_REGISTRY: 'WEDDING_REGISTRY',
  STORE: 'STORE',
  PHOTOBOOK: 'PHOTOBOOK'
};
exports.BUSINESS_UNIT = BUSINESS_UNIT;
var COMPONENT = {
  CHANGE_THE_DATE: 'CHANGE_THE_DATE',
  DAY_OF_PAPER: 'DAY_OF_PAPER',
  FAVORITE: 'FAVORITE',
  HOLIDAY: 'HOLIDAY',
  INQUIRY: 'INQUIRY',
  INSPIRATION: 'INSPIRATION',
  // Deprecated: Use MARKETPLACE for marketplace couples
  INVITATIONS: 'INVITATIONS',
  MARKETPLACE: 'MARKETPLACE',
  MARKETPLACE_COUPLES: 'MARKETPLACE_COUPLES',
  // Deprecated: Use MARKETPLACE for marketplace couples
  MARKETPLACE_MATCH: 'MARKETPLACE_MATCH',
  // Deprecated
  MARKETPLACE_QUIZ: 'MARKETPLACE_QUIZ',
  REAL_WEDDINGS: 'REAL_WEDDINGS',
  REGISTRY: 'REGISTRY',
  SAVE_THE_DATE: 'SAVE_THE_DATE',
  THANK_YOU_CARDS: 'THANK_YOU_CARDS',
  WEDDINGS: 'WEDDINGS',
  WEDDING_CHECKLIST: 'WEDDING_CHECKLIST',
  WEDDING_GUEST_LIST: 'WEDDING_GUEST_LIST',
  WEDDING_PLANNING: 'WEDDING_PLANNING',
  WEDDING_WEBSITE: 'WEDDING_WEBSITE',
  // For marketplace vendors
  BANDS_DJS: 'BANDS_DJS',
  CAKES_DESSERTS: 'CAKES_DESSERTS',
  CATERING: 'CATERING',
  FLORIST: 'FLORIST',
  HAIR_MAKEUP: 'HAIR_MAKEUP',
  PHOTOGRAPHER: 'PHOTOGRAPHER',
  VENUE: 'VENUE',
  VIDEOGRAPHER: 'VIDEOGRAPHER',
  STORE: 'STORE'
};
exports.COMPONENT = COMPONENT;
var _default = {
  BUSINESS_UNIT: BUSINESS_UNIT,
  COMPONENT: COMPONENT
};
exports.default = _default;